import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from 'react-router-dom';
import './index.css';
import App from './App';
import Sampler from './Sampler';
import { LayoutProvider } from './LayoutContext';
import { SampleProvider } from './SampleContext';

const ProviderWrapper = () => {
    return (
        <LayoutProvider>
            <SampleProvider>
                <Outlet />
            </SampleProvider>
        </LayoutProvider>
    );
};

createRoot(document.getElementById('root')!).render(
    <Router>
        <Routes>
            {/* Wrap all routes in LayoutProvider */}
            <Route path="/X7pL9q" element={<ProviderWrapper />}>
                <Route index element={<Navigate to="deepfake" replace />} />
                <Route path="audio" element={<Sampler />} />
                <Route path="video" element={<Sampler />} />
                <Route path="deepfake" element={<Sampler />} />
                <Route path=":account">
                    <Route index element={<Navigate to="deepfake" replace />} />
                    <Route path="audio" element={<Sampler />} />
                    <Route path="video" element={<Sampler />} />
                    <Route path="deepfake" element={<Sampler />} />
                </Route>
                <Route path=":account/:msp">
                    <Route index element={<Navigate to="deepfake" replace />} />
                    <Route path="audio" element={<Sampler />} />
                    <Route path="video" element={<Sampler />} />
                    <Route path="deepfake" element={<Sampler />} />
                </Route>
            </Route>
            <Route path="/not-found" element={<div className="text-white font-extrabold text-[20px]">Invalid URL</div>} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
        </Routes>
    </Router>
);

